import { Bubble } from '../types';
import { IHexGridData, IHexSpaceData } from 'js/bubbleCore/types';
import { Hex } from 'js/bubbleCore/Hex';
import { getNeighbours } from 'js/bubbleCore/utils/getNeighbours';
import { getBubbleHandler } from 'js/bubbleCore/bubbles/getBubbleHandler';

export function getMatchingBubbles(
  grid: IHexGridData<Bubble>,
  originBubble: Bubble
): Bubble[] {
  const checkedIds: string[] = [];
  const bubblesToCheck: Bubble[] = [originBubble];
  const bubbles: Bubble[] = [];

  const isMatching = getBubbleHandler(originBubble).isMatching;

  for (let i = 0; i < bubblesToCheck.length; i++) {
    const currentBubble = bubblesToCheck[i];
    checkedIds.push(currentBubble.id);

    if (!isMatching(originBubble, currentBubble)) continue;
    if (bubbles.includes(currentBubble)) continue; 
    bubbles.push(currentBubble);
    bubblesToCheck.push(
      ...getNeighbours(grid, currentBubble.col, currentBubble.row)
        .filter((bubble) => !checkedIds.includes(bubble.id))
    );
  }

  return bubbles;
}